w<template>
  <div class="onlineWarp" v-loading="upLoding">
    <div class="onInner"  v-show="type==0">
      <img src="../../assets/images/icon_fangdajing.png">
      <p class="t">在线验签</p>
      <p class="t2">
        验证你持有的文档(PDF文件)是否为通过 ABSIGN平台签署完成的文档<br>验证你持有的文档(PDF文件)有无被篡改
      </p>
      <el-upload
        class="avatar-uploader"
        action="http://www.absign.cn:8080/api/account/verfyPdf"
        :show-file-list="false"
        accept="application/pdf"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload">
        <div class="upBtn"><img src="../../assets/images/icon_shangchuan.png" alt="">点击上传PDF格式合同</div>
      </el-upload>
    </div>
    <div class="onInner"  v-show="type==1">
      <img src="../../assets/images/icon_green.png">
      <p class="t">验签成功</p>
      <p class="t2 c">
        该PDF文件为ABSIGN正常签署得到的文件，并且：
      </p>
      <p class="t2 c">
        1、该文档的签名/签章有效      </p>
      <p class="t2 c">
      2、文档签署时间:{{data}}</p>
      <p class="t2 c">
        3、该文档及所有签名/签章都未被修改  </p>

      <el-upload
        class="avatar-uploader"
        action="http://www.absign.cn:8080/api/account/verfyPdf"
        :show-file-list="false"
        accept="application/pdf"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload"
      >
        <div class="upBtn"><img src="../../assets/images/icon_shangchuan.png" alt="">点击上传PDF格式合同</div>
      </el-upload>
    </div>
    <div class="onInner" v-show="type==2">
      <img src="../../assets/images/icon_red.png">
      <p class="t">验签失败</p>
      <p class="t2">
        该PDF文件中未发现签名信息<br>
        请重新上传。
      </p>
      <el-upload
        class="avatar-uploader"
        action="http://www.absign.cn:8080/api/account/verfyPdf"
        :show-file-list="false"
        accept="application/pdf"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload">
        <div class="upBtn"><img src="../../assets/images/icon_shangchuan.png" alt="">重新上传PDF格式合同</div>
      </el-upload>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
    export default {
      data(){
        return{
          type:0,
          upLoding:false,
          data:''
        }
      },
      methods:{
        handleAvatarSuccess(data){
          this.upLoding = false
          if(data.data){
            this.data = data.data
            this.type = 1;
          }else {
            this.type = 2;
          }
        },
        beforeAvatarUpload(){
          this.upLoding = true
        }
      }
    }
</script>
<style>
  @import "../../assets/less/onlineWarp.css";
</style>



// WEBPACK FOOTER //
// src/components/online/online.vue